export default __webpack_public_path__ + "static/media/ConferenceIcon.097b6d2e.svg";